import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { mergeChartOptions } from "../../pages/Compare/chartTheme";

const TTMRevenue: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], labels = [] } = data || {};

  const chartData: any = {
    options: mergeChartOptions({
      plotOptions: {
        pie: {
          customScale: 0.7,
        },
      },
      chart: {
        id: "TTMRevenue",
        toolbar: { show: true },
      },
      labels,
      dataLabels: {
        enabled: true,
        formatter: (value: string) => {
          return `${parseFloat(value).toFixed(2)}%`;
        },
      },
      legend: {
        showForSingleSeries: true,
      },
    }),
    chart: {
      type: "donut",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">TTM Revenue Comparison</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="donut"
        height={550}
      />
    </div>
  );
};

export default TTMRevenue;
